<script>
	import Layout from "../../layouts/main";
	import PageHeader from "../../components/page-header";
	import extraIncentives from "../extra_incentives/extra_incentives.vue";

	export default {
		components: { Layout, PageHeader, extraIncentives },
		data() {
			return {
				
			}
		}
	}

</script>

<template>
	<Layout>
		<extra-incentives :is_mextra_incentive="true" :restaurantData="[]"/>
	</Layout>
</template>